<script lang="ts">
    import { Route } from 'svelte-navigator';
    import Redirect from '../../kiosk/components/Redirect.svelte';
    import Read from './Read.svelte';
    import New from './New.svelte';
    import backgroundURL from '../assets/wood.avif';
</script>

<div class="page-wrapper" style={`background-image:url('${backgroundURL}')`}>
    <h1 class="heading">Der automatische Geschichtenerzähler</h1>
    <Route path="new">
        <New />
    </Route>
    <Route path="read/:id" let:params>
        <Read id={params.id} />
    </Route>
    <Route path="*">
        <Redirect to={`/story/new`} />
    </Route>
</div>

<style>
    .page-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        height: 100svh;
        width: 100svw;
        position: fixed;
        top: 0;
        left: 0;
    }

    .heading {
        margin: 1rem;
        font-size: 3vw;
        color: #ffff00;
    }
</style>
